'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Flower';

var EntypoFlower = function EntypoFlower(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M12.6591797,8.7595215c0.4396973-1.0861816-0.3630371-2.5083008-1.2099609-3.4055176c0.3283691-1.1893311,0.3718262-2.8215332-0.5253906-3.5754395c-0.8969727-0.7540283-2.4973145-0.4300537-3.6125488,0.0980225C6.2817383,1.1970215,4.7426758,0.651123,3.748291,1.2713623C2.7543945,1.8916016,2.5678711,3.513916,2.7253418,4.7375488c-0.9645996,0.7692871-1.9592285,2.064209-1.6765137,3.201416s1.7678223,1.815918,2.9804688,2.0440674c0.4333496,1.1551514,1.357666,2.5012207,2.5266113,2.5838623c0.828125,0.0585938,1.619873-0.53125,2.223877-1.2633057c1.2209473,1.5201416,2.0817871,3.1278076,2.5551758,4.706543C10.6123047,14.9285889,9.1147461,14,6,14c0,4.1550293,3.0419922,5.0028076,5,5.0028076l3.2001953,0.0020752c0-2.7229004-0.986084-5.909668-3.2895508-8.9008789C11.692627,9.8570557,12.388916,9.4267578,12.6591797,8.7595215z M8.2827148,8.5396729C7.1357422,9.255127,5.6259766,8.9055176,4.9106445,7.7585449C4.1950684,6.6116943,4.5446777,5.1018066,5.6916504,4.3863525S8.3483887,4.020752,9.0639648,5.1674805C9.7792969,6.3144531,9.4296875,7.8242188,8.2827148,8.5396729z M14.0200195,12.2478027c1.0825195,2.1699219,1.6687012,4.4530029,1.6774902,6.7053223C18.9963379,16.5820312,19,12.2062988,19,8.0028076C19,8.0028076,15.3293457,9.0374756,14.0200195,12.2478027z' })
    );
};

exports.default = EntypoFlower;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Flower.js
// module id = 593
// module chunks = 168707334958949